import { useCallback, useEffect, useRef, useState } from 'react';

export const useDialogScroll = () => {
    const [atTop, setAtTop] = useState(true);
    const [atBottom, setAtBottom] = useState(false);

    const modalContentRef = useRef<HTMLDivElement>(null);

    const handleScroll = useCallback(() => {
        if (modalContentRef?.current) {
            const { scrollTop, scrollHeight, clientHeight } = modalContentRef.current;

            setAtTop(scrollTop === 0);
            setAtBottom(scrollTop + clientHeight >= scrollHeight - 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalContentRef?.current]);

    useEffect(() => {
        const modalContent = modalContentRef.current;
        if (modalContent) {
            modalContent.addEventListener('scroll', handleScroll);

            const resizeObserver = new ResizeObserver(() => {
                handleScroll();
            });
            resizeObserver.observe(modalContent);

            return () => {
                modalContent.removeEventListener('scroll', handleScroll);
                resizeObserver.disconnect();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalContentRef?.current]);

    return {
        modalContentRef,
        atTop,
        atBottom,
    };
};
